import { getActiveWidgetDataForThread } from '@/store/reducers/PaperFinderWidgetStore';
import {
  getCurrentOpenWidgetIds,
  getCurrentThread,
} from '@/store/reducers/UIState';
import { getReaderStateForThread } from '@/store/reducers/ReaderWidgetStore';
import { getTableStateForThread } from '@/store/reducers/TableWidgetStore';
import { getWidgetTypefromId } from '@/store/actionCreators/WidgetActions';
import { selectPaperFinderUIStateForWidget } from '@/components/paper-finder/shared/store/selectors/ui-state';
import { WidgetData, WidgetType } from '@/models/PanelWidgets';

import { createSelector } from '@reduxjs/toolkit';

export interface LatestUIState {
  widgetsInView: WidgetData[];
}

export const buildUIState = createSelector(
  [
    getCurrentThread,
    getCurrentOpenWidgetIds,
    (state) => getReaderStateForThread(state, getCurrentThread(state)?.id),
    (state) => getTableStateForThread(state, getCurrentThread(state)?.id),
    (state) => {
      const threadId = getCurrentThread(state)?.id;
      const widgetId = getActiveWidgetDataForThread(state, threadId)?.id;

      return selectPaperFinderUIStateForWidget(state, threadId, widgetId);
    },
  ],
  (currentThread, openWidgetIds, readerData, tableData, paperFinderData) => {
    const openWidgetTypes = openWidgetIds.map((id) => getWidgetTypefromId(id));

    const widgetsInView: WidgetData[] = [];
    openWidgetTypes.forEach((widgetType) => {
      switch (widgetType) {
        case WidgetType.READER:
          if (readerData) {
            widgetsInView.push(readerData);
          }
          break;
        case WidgetType.TABLE:
          if (tableData) {
            widgetsInView.push(tableData);
          }
          break;
        case WidgetType.PAPER_FINDER:
          if (paperFinderData) {
            widgetsInView.push({
              type: WidgetType.PAPER_FINDER,
              ...paperFinderData,
            });
          }
          break;
      }
    });

    return {
      threadId: currentThread?.id,
      widgetsInView,
    };
  },
);
